import { useCurrentLanguage } from '../../../hooks/useCurrentLanguage';
import TEXT from '../../../utils/text/prensa.json'


export default function End({ stepNumber, progress }) {

  const {language} = useCurrentLanguage();
  return (
    progress && (
      <div>
        <p className="w-full md:w-1/2  md:mb-8 mx-auto text-center text-dark-grey font-bold md:pt-16 pt-8 px-4  text-lg md:text-xl desktop:text-2xl">
          {TEXT['mixed_feelings']['end'][language]}
        </p>
        <div  className="sticky top-0 h-screen max-w-[1440px] mx-auto">
          <Parallax
            image={"/images/mixed-feelings/end/image_01.png"}
            className={"top-0         left-4       w-[60%] md:w-[30vw]"}
            progress={progress}
            modifier={100}
          />
         
          <Parallax
            image={"/images/mixed-feelings/end/image_03.png"}
            className={"top-[10%] md:top-[15%]    right-2 ml-auto w-[50%] md:w-[30vw]"}
            progress={progress}
            modifier={200}
          />
          <Parallax
            image={"/images/mixed-feelings/end/image_04.png"}
            className={"top-[20%] md:top-[5%]    left-[35%]          w-[50%] md:w-[30vw]"}
            progress={progress}
            modifier={200}
          />
          <Parallax
            image={"/images/mixed-feelings/end/image_05.png"}
            className={"top-[40%] md:top-[20%]    left-[10%]    w-[60%] md:w-[30vw]"}
            progress={progress}
            modifier={200}
          />
          
          <Parallax
            image={"/images/mixed-feelings/end/image_07.png"}
            className={"md:top-[30%]    top-[50%]    left-[30%]        w-[50%]  md:w-[30vw]"}
            progress={progress}
            modifier={200}
          />
          <Parallax
            image={"/images/mixed-feelings/end/image_06.png"}
            className={"top-0    right-[5%]          w-[50%]  md:w-[30vw]"}
            progress={progress}
            modifier={200}
          />
           <Parallax
            image={"/images/mixed-feelings/end/image_02.png"}
            className={`top-[60%]    right-6       ml-auto   w-[60%]  md:w-[30vw]`}
            progress={progress}
            modifier={200}
          />
        </div>
      </div>
    )
  );
}

function Parallax({
  image,
  modifier,
  progress,
  className,
  currentStepIndex,
  stepNumber,
  ...others
}) {
  const p =
    currentStepIndex !== stepNumber
      ? 1
      : progress && progress.progress
      ? (progress.progress - 0.5) * modifier
      : 0;
  return (
    <img
      {...others}
      src={image}
      alt="parallax"
      style={{ transform: `translateY(${p}px)` }}
      className={` absolute transition-all ${className} 
        ${progress.progress > 0.7 ? "opacity-1" : "opacity-100"}`}
    />
  );
}
